export default "__VITE_ASSET__CF8f9pWk__"